import { NumberPlateBtn } from './NumberPlateBtn';

export default NumberPlateBtn;
